import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { index, integer } from "@-/dev.improve.haniverse.lib.database.table";
import { sql } from "@-/com.npmjs.drizzle-orm";
import { wordTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.word";

export const wordPrcDataTable = staticTable(
  "word_prc_data",
  {
    wordId: integer("word_id")
      .notNull()
      .references(() => wordTable.id),

    // HSK 2.0
    hsk2010Level: integer("hsk_2010_level"),
    // HSK 3.0
    hsk2021Level: integer("hsk_2021_level"),
    // HSK 3.1 (unofficial name)
    hsk2026Level: integer("hsk_2026_level"),

    // NOTE: keep the `hsk*Index` columns AFTER the `hsk*Level` columns. The haniverse-worker deploy
    // loads static.db into D1 with a positional `sqlite3 .dump`, so the column order created from
    // this schema must match D1's. These indexes were added to D1 via `ALTER TABLE ADD`
    // (appended), in this exact order, so any column introduced after the initial migration must
    // be declared at the end here too.
    //
    // Learning-order position of this word within each HSK list (0-based; null when absent).
    hsk2010Index: integer("hsk_2010_index"),
    hsk2021Index: integer("hsk_2021_index"),
    hsk2026Index: integer("hsk_2026_index"),
  },
  (table) => [
    index("word_prc_data_word_id_idx").on(table.wordId),
    // Partial indexes keep `getHskWordSetFromDb`'s `WHERE hsk_*_level IS NOT NULL` off the
    // ~10k-row full table scan that was the worst offender on the Browse Words page. The
    // predicate matches the query verbatim so SQLite picks the index automatically.
    index("word_prc_data_hsk_2010_level_idx")
      .on(table.hsk2010Level)
      .where(sql`hsk_2010_level IS NOT NULL`),
    index("word_prc_data_hsk_2021_level_idx")
      .on(table.hsk2021Level)
      .where(sql`hsk_2021_level IS NOT NULL`),
    index("word_prc_data_hsk_2026_level_idx")
      .on(table.hsk2026Level)
      .where(sql`hsk_2026_level IS NOT NULL`),
  ],
);

export type WordPrcData = typeof wordPrcDataTable.$inferSelect;
